<onsip-fixed-width-card-list width="536px">
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.TOPIC_NAME" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-target-display-form
        [initialValue]="targetDisplay"
        [currentTarget]="currentTarget"
        [isAdding]="isAdding"
      ></onsip-target-display-form>
    </mat-card-content>
  </mat-card>
  <mat-card onsip-list-card>
    <mat-card-title
      >{{ "ONSIP_I18N.TOPIC_REPRESENTATIVES" | translate }} ({{ repCount }})</mat-card-title
    >
    <mat-card-content>
      <onsip-rep-picker
        [initialValue]="reps"
        (updateRepCount)="onUpdateRepCount($event)"
      ></onsip-rep-picker>
    </mat-card-content>
  </mat-card>
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.VIDEO_CALLS" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-video-checkbox [initialValue]="video"></onsip-video-checkbox>
    </mat-card-content>
  </mat-card>
  <mat-card onsip-list-card>
    <mat-card-title>
      {{ "ONSIP_I18N.COUNTRY_AVAILABILITY" | translate }} ({{ countryCount }})
    </mat-card-title>
    <mat-card-content>
      <mat-checkbox
        color="primary"
        [(ngModel)]="countriesChecked"
        (change)="userCountryCheckChange($event)"
        >{{ "ONSIP_I18N.APPEARS_IN_ALL_COUNTRIES" | translate }}</mat-checkbox
      >
      @if (!countriesChecked) {
      <onsip-country-picker
        [initialValue]="countries"
        [countryAvailabilityStrategy]="countryAvailabilityStrategy"
      ></onsip-country-picker>
      }
    </mat-card-content>
  </mat-card>
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.BUSINESS_HOUR_RULES" | translate }}</mat-card-title>
    <mat-card-content>
      <onsip-bhr-picker [initialValue]="bhr"></onsip-bhr-picker>
    </mat-card-content>
  </mat-card>
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.HOLIDAYS" | translate }}</mat-card-title>
    <mat-card-content>
      <mat-checkbox color="primary" [(ngModel)]="holidaysChecked">{{
        "ONSIP_I18N.APPEARS_ON_ALL_DAYS" | translate
      }}</mat-checkbox>
      @if (!holidaysChecked) {
      <onsip-holiday-picker [initialValue]="holidays"></onsip-holiday-picker>
      }
    </mat-card-content>
  </mat-card>
  <mat-card onsip-list-card>
    <mat-card-title>{{ "ONSIP_I18N.PAGE_DISPLAY_RULES" | translate }}</mat-card-title>
    <mat-card-content>
      <mat-checkbox color="primary" [(ngModel)]="pagesChecked">{{
        "ONSIP_I18N.APPEARS_ON_ALL_PAGES" | translate
      }}</mat-checkbox>
      @if (!pagesChecked) {
      <onsip-page-picker [initialValue]="pages"></onsip-page-picker>
      }
    </mat-card-content>
  </mat-card>
</onsip-fixed-width-card-list>
